export default __webpack_public_path__ + "static/media/digital.608d58ec.png";